import { IconsLegacy as Icons } from '@metservicedev/met-ui/icons';
import { IconNameV1 } from 'common/icon/iconV1.js';

export enum ConditionType {
  Cloudy = 'cloudy',
  Drizzle = 'drizzle',
  FewShowersNight = 'few-showers-night',
  FewShowers = 'few-showers',
  FineNight = 'fine-night',
  Fine = 'fine',
  Frost = 'frost',
  Hail = 'hail',
  PartlyCloudyNight = 'partly-cloudy-night',
  PartlyCloudy = 'partly-cloudy',
  Rain = 'rain',
  Showers = 'showers',
  Snow = 'snow',
  Thunder = 'thunder',
  WindRain = 'wind-rain',
  Wind = 'windy',
}

export const iconForCondition = (condition: ConditionType): IconNameV1 => {
  const iconName = `condition-${condition}`;
  return iconName as IconNameV1;
};

export const getNightIcon = (icon: IconNameV1, isNight?: boolean) => {
  if (isNight) {
    const nightIconName = icon.concat('-night');
    if (nightIconName in Icons) {
      return nightIconName as IconNameV1;
    }
  }
  return icon;
};
